//eslinit-disable
/**
 * Monitors focus events on the Chat Interface's text areas, and
 * ensures that the chat stays in view and usaable on mobile-phone browsers.
 *
 *   - "mobile" == Capabilities.isMobile()
 *   - Because we're on "mobile" browsers, we don't support IE
 *   - Because we're on "mobile" browsers, we don't consider persistent chat.
 */
/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitor
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase = function() {
	/** @type {HTMLFrameElement} */
	this.iframe = null;
	/** @type {com.inq.utils.Point} */
	this.windowPosition = null;
	/** @type {com.inq.utils.Area} */
	this.chatArea = null;
	/** @type {boolean} */
	this.hasFocus = false;
	/** @type {null} */
	this.blurToken = null;
	/** @type {null} */
	this.focusToken = null;
	/** @type {boolean} */
	this.inited = false;
	/** @type {number} */
	this.onBlurHandlerScheduleId = 0;
	/** @type {Object} */
	this.orbeonDtidMap = {};
	/** @type {Array} */
	this.keyboardHeightArray = [null, null];
	/** @type {null} */
	this.focusElement = null;
	/** @type {boolean} */
	this.bResizeToViewport = false;
	/** @type {*} */
	this.curScroll = null;
	/** @type {*} */
	this.focusScroll = null;
	/** @type (number} */
	this.tapTimer = 0;
	/** @type (number} */
	this.scrollState = 0;
	/** @type {com.inq.utils.Point} */
	this.viewPort = null;

    // Bind all methods to this instance.
    $bindAll(this);
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.isTouched = false;

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.CONST = {
	RESIZE_DELAY_MS: 250,
	RESIZE_DELAY_MS_IPHONE_13: 500
};

/**
 * init - Initializes ChatTextFocusMonitorImplBase.  DOES NOTHING if the
 * user agent is NOT a 'mobile' browser, OR if the user agent
 * doesn't automatically zoom in to text fields.  So this doesn't
 * have to work in IE, Firefox, et al.
 *
 * TODO Please make sure in next iteration that we do not access html elements directly
 * The proper way is to get it from the TextArea object.
 * TODO Please add try catch arround this init, so not to stop and break subsequent inits for other classes.
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function init():Bool
 * @public
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.init = function() {
	if(!com.inq.utils.Capabilities.isMobile() || !com.inq.utils.Capabilities.isAutoZoom()) {
        this.inited = false;
        return this.inited;
    }
	if (window.top.pageYOffset == 0) {
		window.top.scrollBy(0, 1);
	}
	/*  Find the HTML elements to bind to. */
    // TODO: Should be com.inq.ui.Stage.getStageElement();
	this.iframe = com.inq.ui.Container._getElementById("inqChatStage",window.parent.document);
	/* The text-area can be in the IFRAME or in the client area.
	 * So we MUST look in both places
	 * This should be fixed - please see TODO above.
	 */

	this.bindListeners();
	/* Clear the DTID map */
	this.orbeonDtidMap = {};
	/* Publish the bind and unbind so Orbeon javascript can access */
	com.inq.utils.Util.publish("Inq.xforms.bindOrbeonListeners", this.bindOrbeonListeners)
	com.inq.utils.Util.publish("Inq.xforms.unbindOrbeonListeners", this.unbindOrbeonListeners)
	this.inited = true;
    return this.inited;
};


/**
 * Close
 * Remove event handlers attached to textArea..
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function Close():Void
 * @public
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.Close = function() {
    if (!this.inited) return;
	this.unbindListeners();
	if(this.blurToken != null) {
		window.clearInterval(this.blurToken);
		this.blurToken = null;
	}
	if(this.focusToken != null) {
		window.clearInterval(this.focusToken);
		this.focusToken = null;
	}
    this.inited = false;
};


/**
 * bindListeners
 * @static
 * @private
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.bindListeners = function() {
	/** @type {HTMLElement} */
	var stageDiv = com.inq.ui.Stage.getStageElement();
	var titleBarDiv = Application.application.getTitleBarElement();
	if (!com.inq.utils.Capabilities.isIpad()) {
		com.inq.utils.Capabilities.BindListener(stageDiv, "touchstart", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchStart);
		com.inq.utils.Capabilities.BindListener(stageDiv, "touchend", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchEnd);
		if(titleBarDiv && com.inq.utils.Capabilities.isIphone()) {
			com.inq.utils.Capabilities.BindListener(titleBarDiv, "touchstart", Application.onTitleBarTouch);
		}
	}
	/** @type {Array} */
	var arr = ["txtInput", "emailInput"];
	for (var i = 0; i < arr.length; i++) {
		try {
			/** @type {string} */
			var n = arr[i];
			/** @type {com.inq.ui.TextInput} */
			var container = Application.application.getTextInput(n);
			if (!container) continue;
			/** @type {HTMLElement} */
			var input = container.getInput();
			if (input != null) {
				com.inq.utils.Capabilities.BindListener(input,"focus", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus);
				com.inq.utils.Capabilities.BindListener(input,"blur", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur);
				com.inq.utils.Capabilities.BindListener(input,"paste", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onPaste);
			}
		} catch (err) {
			haxe.Log.trace("Error: " + err, { fileName : "ChatTextFocusMonitorImplBase.js", lineNumber : 167, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase", methodName : "bindListeners"});
		}
	}
};

/**
 * bindOrbeonListeners
 *
 * @private
 * @param {string} dtid - descision table identifier.
 * @param {Array} fields - array of fields to be listened to for focus
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.bindOrbeonListeners = function(dtid, fields) {
	for (var i = 0, len = fields.length; i < len; i++) {
		/** @type {?HTMLElement} */
		var el = fields[i];
		if (el != null) {
			com.inq.utils.Capabilities.BindListener(el,"focus", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus);
			com.inq.utils.Capabilities.BindListener(el,"blur", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur);
			com.inq.utils.Capabilities.BindListener(el,"paste", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onPaste);
		}
	}
	this.orbeonDtidMap[dtid] = fields;

};

/**
 * unbindOrbeonListeners
 * dtid is a key to an array of xform elements to be no longer listened to.
 * @private
 * @param {string} dtid - descision table identifier.
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.unbindOrbeonListeners = function(dtid) {
	var fields = this.orbeonDtidMap[dtid];
	if (fields) {
		for (var i = 0, len = fields.length; i < len; i++) {
			/** @type {?HTMLElement} */
			var el = fields[i];
			if (el != null) {
				com.inq.utils.Capabilities.UnbindListener(el,"focus", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus);
				com.inq.utils.Capabilities.UnbindListener(el,"blur", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur);
				com.inq.utils.Capabilities.UnbindListener(el,"paste", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onPaste);
			}
		}
		this.orbeonDtidMap[dtid] = null;
	}
};


/**
 * blur
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function blur()
 * @public
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.blur = function() {
	if(this.focusElement != null) this.focusElement.blur();
};


/**
 * unbindListeners
 *
 * $type TFun([],TEnum(Void,[]))
 * static private function unbindListeners()
 * @private
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.unbindListeners = function() {
	/** @type {HTMLElement} */
	var stageDiv = com.inq.ui.Stage.getStageElement();
	var titleBarDiv = Application.application.getTitleBarElement();
	if(!com.inq.utils.Capabilities.isIpad()) {
		com.inq.utils.Capabilities.UnbindListener(stageDiv, "touchstart", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchStart);
		com.inq.utils.Capabilities.UnbindListener(stageDiv, "touchend", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchEnd);
		if(titleBarDiv && com.inq.utils.Capabilities.isIphone()) {
			com.inq.utils.Capabilities.UnbindListener(titleBarDiv, "touchstart", Application.onTitleBarTouch);
		}
	}
	/** @type {Array} */
	var arr = ["txtInput", "emailInput"];
	for (var i = 0; i < arr.length; i++) {
		/** @type {string} */
		var n = arr[i];
		/** @type {com.inq.ui.TextInput} */
		var container = Application.application.getTextInput(n);
		if(container == null) continue;
		/** @type {HTMLElement} */
		var input = container.getInput();
		if(input != null) {
			com.inq.utils.Capabilities.UnbindListener(input,"focus", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus);
			com.inq.utils.Capabilities.UnbindListener(input,"blur", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur);
			com.inq.utils.Capabilities.UnbindListener(input,"paste", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onPaste);
		}
	}
};


/**
 * HasFocus
 *
 * $type TFun([],TEnum(Bool,[]))
 * static public function HasFocus():Bool
 * @public
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.HasFocus = function() {
	return this.hasFocus;
};

/**
 * setHasFocus - is used to set flag to detect focus on input elements.
 *
 * @param {boolean} - [focused=true]
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.setHasFocus = function (focused) {
	this.hasFocus = focused === undefined ? true : focused;
};

/**
 * @public
 * @return HTMLInputElement
 *
 */

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.getFocusElement = function() {
	return this.focusElement;
};


/**
 * scrollToPrevious
 * Scroll to the previous position
 * Call this only after saveWindowPosition has been called
 * *
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function scrollToPrevious():Void
 * @public
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.scrollToPrevious = function() {
	if(this.windowPosition != null) com.inq.flash.client.chatskins.ScrollMonitor.ScrollTo(this.windowPosition.x,this.windowPosition.y);
};


/**
 * saveWindowPositionForce
 * Helper function for restoreWindowPosition. Refactored in RTDEV-3840 because there is
 * a conditional in saveWindowPosition that only detects if things are not minimized.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function saveWindowPositionForce():Void
 * @public
 * @see restoreWindowPosition
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.saveWindowPositionForce = function() {
	this.windowPosition = com.inq.utils.Capabilities.getViewport();
	/* Make sure that the Y position is not zero, but one, this is so we do not show the location bar on phones */
	if (this.windowPosition.y == 0) {
		this.windowPosition.y = 1;
	}

	this.chatArea = Application.GetArea();
};


/**
 * saveWindowPosition
 * Save the current window and chat interface posisitions.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function saveWindowPosition():Void
 * @public
 * @see restoreWindowPosition
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.saveWindowPosition = function() {
	if(this.windowPosition == null && this.chatArea == null) {
		this.windowPosition = com.inq.utils.Capabilities.getViewport();
		this.chatArea = Application.GetArea();
	}
};

/**
 * clearWindowPosition
 * Clear the current window and chat interface posisitions.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function saveWindowPosition():Void
 * @public
 * @see restoreWindowPosition
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.clearWindowPosition = function() {
	this.windowPosition = null;
	this.chatArea = null;
};

/**
 * hasSavedWindowPosition
 * Do we have a saved window position?
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function saveWindowPosition():Void
 * @public
 * @see restoreWindowPosition
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.hasSavedWindowPosition = function() {
	return (this.windowPosition != null
            && this.chatArea != null);
};

/**
 * restoreWindowPosition
 * Restore the saved window and chat interface posisitions.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function restoreWindowPosition():Void
 * @public
 * @see saveWindowPosition
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.restoreWindowPosition = function() {
	/** @type {com.inq.ui.Stage} */
	var stage = com.inq.ui.Stage.getInstance();
	/** @type {boolean} */
	var stageIsVisible = stage.getVisible();
	var __this__ = this;

	if(Application.IsPersistent()) {
		com.inq.flash.client.chatskins.ScrollMonitor.ScrollToTop();
		/** @type {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase} */
		com.inq.utils.Timer.delay(function() {
			__this__.resizeToViewport("restore 1");
		}, this.CONST.RESIZE_DELAY_MS);
	} else {
		if(this.windowPosition != null) {
			com.inq.flash.client.chatskins.ScrollMonitor.ScrollTo(this.windowPosition.x,
																  this.windowPosition.y);
		}
		if(com.inq.utils.Capabilities.isPhone() && this.chatArea == null) {
			com.inq.utils.Timer.delay(function() {
				__this__.resizeToViewport("restoreWindowPosition");
			}, this.CONST.RESIZE_DELAY_MS);
		}
		/*  handles the ScrollTo call above AFTER this thread */
		/*  has finished. */
		if(this.chatArea != null) {
			Application.SetArea(this.chatArea);
		}
	}
	stage.setVisible(stageIsVisible);
	this.windowPosition = this.chatArea = null;/*  Null out the saved positions.*/
};

/**
 * FixIPhoneFocusScroll
 * Fix the positioning of an element after focus messes it up :)
 *
 * @private
 * @return {boolean} true if correction is needed
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.FixIPhoneFocusScroll = function() {
	/* Move scrolling to the correct position */
	if (this.focusScroll.X != top.scrollX ||
		this.focusScroll.Y != top.scrollY)
    {
		window.top.scrollTo(this.focusScroll.X, this.focusScroll.Y);
		return true
	}
	else {
		return false;
	}
}


/**
 * onFocus - Handler for focus events on the chat interface's text
 * input area.
 *
 * This includes a hack to get around a quirk of iOS.
 *
 *
 * THE QUIRK:
 *
 * Safari on iOS does NOT take the on-screen keyboard
 * into account when reporting values for
 * window.innerWidth/Height.
 *
 * THE WORK-AROUND:
 *
 * If we scroll the page all the way to the bottom, the bottom of
 * the visible area will line up with the top of the on-screen
 * keyboard.  In this state, window.innerWidth/Height reflects the
 * actual visible portion of the page, which is now exactly small
 * enough to fit above the on-screen keyboard.
 *
 * IN A NUTSHELL:
 *
 * By scrolling the page all the way to the bottom, we force iOS
 * to correctly report the size of the current viewport above the
 * keyboard.
 *
 * $type TFun([],TEnum(Bool,[]))
 * static public function onFocus():Bool
 * @public
 * @param {FocusEvent}  ev
 * @param {HTMLElement) element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onFocus = function(ev, element) {
	var isButtonHasFirstFocus = com.inq.flash.client.chatskins.SkinControl.accessibilityHelp.isButtonHasFirstFocus;
	// MOB-569: For tablets, we don't do the normal resize, but we DO
	// need to momentarily disable the ScrollMonitor's "float"
	// behavior so that the keyboard doesn't end up on top of the CI.
	this.setHasFocus(true);
	this.focusElement = element;
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.isTouched = true;
	if (com.inq.utils.Capabilities.isTablet() && !Application.IsPersistent()) {
		com.inq.flash.client.chatskins.ScrollMonitor.suspend();
		com.inq.utils.Capabilities.waitFor(com.inq.utils.Capabilities.viewportStopsMoving(800), 200, function() {
			com.inq.flash.client.chatskins.ScrollMonitor.resume();
			com.inq.flash.client.chatskins.ScrollMonitor.moveChat(true);
		});
		return false;
	} else if (ev && !ev.relatedTarget && !this.isInputElement(ev.target) && !this.focusScroll) {
		/**
		 * select popup doesn't appear when the focus is set to select by automaton. so there is not need to resize the window
		 */
		this.saveScrollPosition();  // This sets curScroll, needed by FixIPhoneFocusScroll.
		this.focusScroll = this.curScroll;
		this.setHasFocus(false);
		return;
	} else {
		if (isButtonHasFirstFocus === true)	{
			com.inq.flash.client.chatskins.SkinControl.accessibilityHelp.isButtonHasFirstFocus = false;
		}
		this.savePosition();
		return this.onFocusImpl(ev, element);
	}
};

/**
 * savePosition - is used to save the scroll position and window position
 * to work with resizing of the chat.
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.savePosition = function() {
	this.saveScrollPosition();
	this.focusScroll = this.curScroll;
	this.saveWindowPosition();
};

/**
 * This is currently (as of MOB-599) a bucket to hold everything that
 * needs to be moved into subclasses.
 *
 * @deprecated
 * @public
 * @param {FocusEvent} ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onFocusRelatedTargetImpl = function(ev) {
	this.setHasFocus(true);
	this.FixIPhoneFocusScroll();
	/** @type {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase} */
	var __this__ = this;
	com.inq.utils.Timer.delay(function () {
		__this__.resizeToViewportFocused();
	}, this.CONST.RESIZE_DELAY_MS);
	return false;
};


/**
 * This is currently (as of MOB-599) a bucket to hold everything that
 * needs to be moved into subclasses.
 *
 * @public
 * @param {FocusEvent} ev
 * @param {HTMLElement) element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onFocusImpl = function(ev,  element) {
	/*  If we try to re-scroll the window in the same thread, we */
	/*  get ignored. This waits for the OS-driven zooming and */
	/*  scrolling to finish.  FIXME: I'd LOVE to find a more robust */
	/*  method of timing/chaining this. */
	if(com.inq.utils.Capabilities.isPhone() || com.inq.utils.Capabilities.isIpad() && Application.IsPersistent()) {
		this.focusElement = element;
		this.focusToken = null;

		this.bindOrientationListener();
		this.fixChatPosition();
	}

	return true;
};

/**
 * fixChatPosition - is used to return the chat to its normal position on the screen,
 * after setting the focus to the input field and scrolling up.
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.fixChatPosition = function() {
	/** @type {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase} */
	var that = this;

	/*
	* Timer delay set to zero because? this calls scroll to bottom and adds a handler
	* for when we scroll back up because of keyboard bump- and need to resize
	*/
	com.inq.utils.Timer.delay(function() {
		that.FixIPhoneFocusScroll();
		that.resizeToViewport("onFocus");
	},0);
};

/**
 * expandChat - is used like stub
 * @return {boolean} - returns false as a default value
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.expandChat = function() {
	return false;
};

/**
 * shrinkChat - is used like stub
 * @return {boolean} - returns false as a default value
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.shrinkChat = function() {
	return false;
};

/**
 * onTouchStart - Capture window scroll position at start of touch event
 *
 * @public
 * @see onTouchEnd
 * @see onFocus
 * @param {Event} ev
 * @param {HTMLElement} element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onTouchStart = function(ev, element) {
    // Remember the current scroll position of the page.
	this.saveScrollPosition();
	return true;
};

/**
 * saveSrollPosition: Save the current page scroll position for use by FixIPhoneFocusScroll.
 *
 * @private
 * @see FixIPhoneFocusScroll
 * @see onFocus
 * @return {Void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.saveScrollPosition = function() {
	this.curScroll = {X: top.scrollX, Y: top.scrollY};
};

/**
 * onMouseDown
 *
 * @private
 * @param {Event}
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onMouseDown = function(ev) {
	return true;
};

/**
 * onTouchMove
 *
 * @private
 * @param {Event}
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onTouchMove = function(ev) {
	return true;
};

/**
 * onTouchEnd - Restore window scroll position at end of touch event
 *
 * @private
 * @param {Event}
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onTouchEnd = function(ev) {
	top.scrollTo(this.curScroll.X, this.curScroll.Y);
	return true;
};

/**
 * zoomViewport
 * Resize the chat so that it fills the viewport.
 *
 * @private
 * @param {*}  clientWin - the window of our client
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.zoomViewport = function(clientWin) {
	if(com.inq.utils.Capabilities.isPhone()) {
		/* Figure out the zoom level */
		/** @type {number} */
		var newZoom = com.inq.stage.ViewportMgr.getChatZoomLevel();
		if(newZoom != Application.initialZoom) {
			Application.initialZoom = newZoom;
			Application.application.setStyle("zoom","" + Application.initialZoom);
		}
	}
};

/**
 * resizeToViewport
 * Resize the chat so that it fills the viewport.
 *
 * This is what we want to do:
 *	 1) disable the scroll monitor, it messes us up for our sizing of the viewport
 *	 2) If we have focus and on iphone or ipad, we want to
 *		2a) scroll to the bottom, this requires us to:
 *			* change the clients body style to allow us to scroll down, we change the minHeight and minWidth
 *			* to set listener for scroll the scroll down.
 *			* At completion of scroll down, get viewport and restore body minHeight and minWidth
 *			* Reenable scroll monitor
 *	3) No focus,
 *		get viewport size
 *		reenable scroll monitor
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function resizeToViewport():Void
 * @public
 * @param {string}  from
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.resizeToViewport = function(from) {
    // If chat is minimized, I do not want to resize chat.
    if (this.bResizeToViewport || com.inq.flash.client.control.MinimizeManager.minimized)
        return;
	this.bResizeToViewport = true;
	/** @type {Window} */
	var clientWin = window.top;

    // if its a device with a virtual keyboard and we are responding to focus event ( on a text input ).. we are resizing to make room for keybd
	if (this.hasFocus && (com.inq.utils.Capabilities.isPhone() || com.inq.utils.Capabilities.isIpad())) {
        this.resizeToViewportImpl();
	}
    else {
		this.zoomViewport(clientWin);
		com.inq.flash.client.chatskins.ScrollMonitor.bindAll();
		try {
			var viewPort = com.inq.utils.Capabilities.getViewport();
			Application.SetArea(viewPort);
			Application.Resize();
			this.bResizeToViewport = false;
		} catch (err) {
			haxe.Log.trace("Error: " + err, { fileName : "ChatTextFocusMonitorImplBase.js", lineNumber : 111, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase", methodName : "resizeToViewport"});
		}
	}
};

/**
 * Holds implementation-specific portion of resizeToViewport.
 *
 * @public
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.resizeToViewportImpl = function() {
	var viewPort = com.inq.utils.Capabilities.getViewport();
	Application.SetArea(viewPort);
	Application.Resize();
	this.zoomViewport(clientWin);
    this.scrollTranscriptToEnd(from);

	/* Restore scroll position via timer delay */
	/** @type {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase} */
	var __this__ = this;
	com.inq.utils.Timer.delay(function() {
		__this__.FixIPhoneFocusScroll();
	},0);
	this.bResizeToViewport = false;
};

/**
 * Scrolls the transcript to the end.
 *
 * @public
 * @param {string} from
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.scrollTranscriptToEnd = function(from) {
	com.inq.utils.Timer.delay(function() {
		com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
	}, 1);
};


/** resizeToViewportFocused - Resize the chat area when we have focus and the virtual keyboard is in view
 * @private
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.resizeToViewportFocused = function() {
	/** @type {number} */
	var keyboardHeight = this.getKeyboardHeight();
	/** @type {Window} */
	var clientWin = window.parent;
	if (keyboardHeight) {
		viewPort = com.inq.utils.Capabilities.getViewport();
		viewPort.h = this.adjustFocusedHeight(viewPort.h);
		viewPort.h -= keyboardHeight;
		Application.SetArea(viewPort);
		Application.Resize();
		this.zoomViewport(clientWin);

		// Delay allows DOM to re-render before we try to scroll.
		// However, Android takes its sweet time about
		// re-rendering, and doesn't schedule things like iOS
		// does, so we have to add a longer delay.
		if (com.inq.utils.Capabilities.isAndroid()) {
			com.inq.utils.Capabilities.waitFor(com.inq.utils.Capabilities.viewportStopsMoving(800), 200, function() {
				com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
			});
		}
		else {
			com.inq.utils.Timer.delay(function() {
				com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
			}, 1);
		}
	}
};


/**
 * adjustFocusedHeight - adjust the sizing of the focused height when the bookmark bar is hidden
 * When the bookmark bar is hidden, the size of the chat with keyboard visible is off by 44 pixels
 * This is an iOS 7.0 7.1 bug
 *
 * We know if we have a bookmarks bar by the browser overhead (availHeight - innerHeight)
 *  If the overhead is less than 32 pixels (Actually 19, then the browser bar is not in view
 *  If the overhead is around 89, then the browser bar and large location bar are in view
 *
 * @private
 * @param {number} viewportHeight to be adjusted
 * @return {number} corrected size
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.adjustFocusedHeight = function(viewportHeight) {
	return viewportHeight;
};


/**
 * getKeyboardHeight
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.getKeyboardHeight = function() {
	var h = this.keyboardHeightArray[(com.inq.utils.Capabilities.getOrientation()) ? 0 : 1] ;
	return h;
}

/**
 * setKeyboardHeight
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.setKeyboardHeight = function(keyboardHeight) {
	this.keyboardHeightArray[(com.inq.utils.Capabilities.getOrientation()) ? 0 : 1] = keyboardHeight ;
}

/**
 * bindOrientationListener
 * Start listening for orientation events.
 *
 * $type TFun([],TEnum(Void,[]))
 * static private function bindOrientationListener():Void
 * @private
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.bindOrientationListener = function() {
	/** @type {Window} */
	var clientWin = window.parent;
	this.unbindOrientationListener();
	com.inq.utils.Capabilities.BindListener(clientWin,"orientationchange", this.onOrientationChange);
};


/**
 * unbindOrientationListener
 * Stop listening for orientation events.
 *
 * $type TFun([],TEnum(Void,[]))
 * static private function unbindOrientationListener():Void
 * @private
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.unbindOrientationListener = function() {
	var clientWin = window.parent;
	com.inq.utils.Capabilities.UnbindListener(clientWin,"orientationchange", this.onOrientationChange);
};

/**
 * onOrientationChange
 * Respond to orientation changes.
 *
 * $type TFun([{ name => ev, t => TType(js.Event,[]), opt => false }],TEnum(Bool,[]))
 * static public function onOrientationChange(ev:Event):Bool
 * @public
 * @param {js.Event}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onOrientationChange = function(ev) {
	if (com.inq.ui.Stage.getInstance().getVisible()) {
        if (this.hasFocus) {
            this.clearWindowPosition(); // The old position is no longer valid.
            this.blur(); // This will resize the chat appropriately.
        }
        else {
            // Since we don't have focus, there's no need to call blur().  Just resize appropriately.
	        /** @type {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase} */
	        var __this__ = this;
		    com.inq.utils.Timer.delay(function() {
			    __this__.resizeToViewport("onOrientationChange:" + ev.type);
		    }, this.CONST.RESIZE_DELAY_MS);
	    }
	}
	return true;
};


/**
 * com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.onBlurHandlerPhoneIphone
 *   For iPhone only, Restore the original scroll position & chat dimensions.
 *
 * @public
 * @return
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onBlurHandlerPhoneIphone = function() {
	this.unbindOrientationListener();

	this.blurToken = null;
	if(!com.inq.flash.client.control.MinimizeManager.minimized) {
		if (!com.inq.utils.Capabilities.isIOSWebView() || com.inq.utils.Capabilities.isTablet()) {
			this.clearWindowPosition();
			this.restoreWindowPosition("onBlurHandlerPhoneIphone");
		} else { /* iOS native app needs moveSizeDiv2Stage call */
			if (com.inq.utils.Capabilities.isIOSWebView()) {
				this.resizeToViewport("onBlurHandlerPhoneIphone");
			}
			var vpArea = com.inq.utils.Capabilities.getViewport();
			Application.MoveSizeDiv2Stage(vpArea.w, vpArea.h, Application.application.area.x, Application.application.area.y);
			Application.Resize();
		}
	}
};

/**
 * onPaste - Strip trailing newlines from text pasted into the text input.
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => true }],TEnum(Bool,[]))
 * static public function onPaste(?me:MouseEvent):Bool
 * @public
 * @param {com.inq.events.MouseEvent}  evt
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onPaste = function(evt) {
    haxe.Timer.delay(function() {
        var txt = evt.srcElement;
        txt.value = txt.value.replace(/\n*$/, "");
    }, 10);
    return true;
};


/**
 * Allows client code to determine whether a blur handler is pending.
 *
 * @return {Boolean} Is there a pending handler?
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.isBlurHandlerPending = function() {
    return this.onBlurHandlerScheduleId != null;
};

/**
 * Cancels a pending blur handler.  It's necessary to encapsulate this
 * so that client code need not be aware of whether we've used
 * window.setTimeout or Capabilities.setDomSafeTimeout to create the
 * delay.
 *
 * @return {Void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.cancelBlurHandler = function() {
    switch (typeof this.onBlurHandlerScheduleId) {
    case "object":
        try {
            this.onBlurHandlerScheduleId.clear();
        }
        catch (e) {
            clearTimeout(this.onBlurHandlerScheduleId);
        }
        break;
    default:
        clearTimeout(this.onBlurHandlerScheduleId);
        break;
    }
    this.onBlurHandlerScheduleId = null;
};

/**
 * onBlur - Restore the original scroll position & chat dimensions.
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => true }],TEnum(Bool,[]))
 * static public function onBlur(?me:MouseEvent):Bool
 * @public
 * @param {FocusEvent}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onBlur = function(ev) {
	/* Find out who has focus now ... It may be another input field */
	if (ev && ev.relatedTarget) {
		/* Send Button Click without text */
		if(com.inq.utils.Capabilities.isAndroidWebView() && ev.relatedTarget.id === "tcChat_btnSend_img" && ev.currentTarget.value === "") {
			ev.stopPropagation();
			try {
				com.inq.flash.client.chatskins.SkinControl.getTextInputField().setFocus(true);
			} catch (err) { /* Continue */ }
			return false;
		}
		if (this.isInputElement(ev.relatedTarget)) {
			// Still need to reset status in phone with virtual keyboard
			if (com.inq.utils.Capabilities.isIphone() && com.inq.utils.Capabilities.isSafari() && !ev.relatedTarget.onfocus) {
				ev.relatedTarget.onfocus = com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus;
				ev.relatedTarget.onblur = com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur;
			}
			/* Yes we are at another input field so we will NOT reset hasFocus and will NOT resize to viewport */
			return false;
		}
	}

	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.isTouched = false;
    return this.onBlurImpl(ev);
};

/**
 * isInputElement - used to check that the element is editable
 *
 * @param {HTMLElement} elem
 * @returns {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.isInputElement = function(elem) {
	var elemName =  elem.nodeName.toUpperCase();
	// We use input type checking in accordance with the blacklist principle, since in the future new input types may appear.
	var notEditableTypesArray = [
		"BUTTON",
		"CHECKBOX",
		"FILE",
		"HIDDEN",
		"RADIO",
		"RESET",
		"SUBMIT",
		"COLOR",
		"RANGE",
		"IMAGE"
	];

	return ((elemName === "INPUT" && !notEditableTypesArray.includes(elem.type.toUpperCase()))
		|| elemName === "TEXTAREA");
};

/**
 * blurFocusedElement - blur focused element
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.blurFocusedElement = function() {
};


/**
 * This is currently (as of MOB-599) a bucket holding all the stuff
 * that needs to be moved into subclasses.
 *
 * @private
 * @param {FocusEvent} ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onBlurImpl = function(ev) {
	this.setHasFocus(false);

	if (com.inq.utils.Capabilities.isIphone()) {
		// We need the timeout, but on iOS this causes rendering
		// bugs. So we need a way to fire timeouts while still letting
		// the DOM be ready.  So we wrap that functionality in
		// Capabilities.setDomSafeTimeout, and call it from here.
		this.onBlurHandlerScheduleId =
			com.inq.utils.Capabilities.setDomSafeTimeout(
				this.onBlurHandlerPhoneIphone,
				1);
	} else if (com.inq.utils.Capabilities.isPhone()
		|| (com.inq.utils.Capabilities.isIpad() && Application.IsPersistent())
	) {
		this.unbindOrientationListener();
		/*  Wait for the screen to quiesce, then restore the window */
		/*  position.  BUT, only restore the window position if */
		/*  we're not minimized and we don't have focus. */

		this.blurToken = null;
		if (!com.inq.flash.client.control.MinimizeManager.minimized) {
			/** @type {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase} */
			var __this__ = this;
			com.inq.utils.Timer.delay(function () {
				__this__.resizeToViewport("onBlur:544");
			}, this.CONST.RESIZE_DELAY_MS);
		}
	} else {
		/*  Simply notify the ScrollMonitor, since iOS doesn't fire */
		/*  a scroll event when the keyboard recedes. */
		com.inq.flash.client.chatskins.ScrollMonitor.notify();
	}
	return true;
};

/**
 * Tells us whether we're running on iOS 6. Putting
 * this here as an emergency fix.  FIXME: Move this into Capabilities
 * ASAP.
 *
 * @return {string} system version
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.isIos6 = function()
{
	/** @type {string} */
	var agent = com.inq.utils.Capabilities.getUserAgent();
    return agent.indexOf("iPhone OS 6_") != -1;
}

/**
 * onScrollCallback - callback for the scroll monitor for specific action per implementation
 *
 * @see com.inq.flash.client.chatskins.ScrollMonitor.whenPhoneScroll
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onScrollCallback = function(){
};

/**
 * calculateViewableArea - calculates the actual viewable area after considering the keyboard height per implementation
 *
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.calculateViewableArea = function () {
};
